export const SORT_OPTIONS = Object.freeze({
  UPDATED_DESC: { field: 'conversationUpdatedAt', direction: 'DESC' },
  CREATED_DESC: { field: 'createdAt', direction: 'DESC' },
});

export const SORT_OPTIONS_LIST = [
  { id: 'UPDATED_DESC', label: 'Last Updated' },
  { id: 'CREATED_DESC', label: 'Date Created' },
];

export const parseSortOption = (sortOrder) => {
  if (!sortOrder || !SORT_OPTIONS[sortOrder]) {
    return null;
  }
  return SORT_OPTIONS[sortOrder];
};
